import { useSession } from './use-session'

export function useMemberTags() {
  const { data: session } = useSession()

  const memberTags = session?.user?.member.memberTags || []

  return memberTags.toString()
}
